<template>
  <b-form-group
    label="Açıklama"
    label-for="summary"
  >
    <b-form-textarea
      id="summary"
      v-model="dataItem.summary"
      placeholder="Açıklama"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'ContentText',
  components: { BFormTextarea, BFormGroup },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
